// extracted by css-extract-rspack-plugin
export default {"pusherAvatar":"Pusher-module__pusherAvatar__jXMgE"};